import React from 'react';
import './TipsModal.less';

function TipsModal(props) {
  const { tipsContent } = props;
  return (
    <div className="tips__modal">
      {tipsContent}
    </div>
  );
}

export default TipsModal;



// WEBPACK FOOTER //
// ./src/components/common/modals/TipsModal/TipsModal.jsx